import { Typography, Box, Button, styled, Fade, Paper } from '@mui/material';
import ErrorIcon from '@acorn-portal/shared/src/assets/motorcade/Motorcade_Cade_Error.svg';
import { Link } from 'react-router';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';

const ImageWrapper = styled('div')(({ theme }) => ({
	'& svg': {
		height: 'auto',
		width: '20em',
		[theme.breakpoints.down('md')]: {
			maxWidth: '220px',
		},
	},
}));
const FLAG_WEB_CHAT_URL = 'https://flaginsurance.co.uk/';

const ServiceUnavailable = () => {
	return (
		<Fade in>
			<Box
				sx={(theme) => ({
					[theme.breakpoints.up('md')]: {
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						minHeight: '100vh',
					},
				})}
			>
				<Paper
					sx={{
						p: 2,
						py: 4,
						display: 'flex',
						flex: 1,
						flexDirection: 'column',
						alignItems: 'center',
					}}
				>
					<Typography
						variant='h4'
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								fontSize: '2rem',
							},
						})}
						color='secondary'
						gutterBottom
						textAlign='center'
					>
						Scheduled Maintenance Underway
					</Typography>
					<ImageWrapper>
						<ErrorIcon />
					</ImageWrapper>
					<Typography
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: {
								fontSize: '1rem',
							},
						})}
						variant='h5'
						color='secondary'
						gutterBottom
						textAlign='left'
					>
						Thanks for visiting the Flag Customer Portal! We&apos;re currently enhancing our portal to serve you better.
						While we fine-tune things, we invite you to use our{' '}
						<Link to={FLAG_WEB_CHAT_URL} target='_blank' rel='noopener noreferrer' reloadDocument>
							{FLAG_WEB_CHAT_URL}
						</Link>{' '}
						on the Flag homepage for any immediate assistance. We&apos;ll be back shortly. Thank you for your patience
						and understanding.
					</Typography>
					<Button
						href={FLAG_WEB_CHAT_URL}
						target='_blank'
						rel='noopener noreferrer'
						variant='contained'
						color='primary'
						sx={{ mt: 2, minWidth: '40%' }}
						endIcon={<ChatBubbleIcon />}
					>
						Chat Now
					</Button>
				</Paper>
			</Box>
		</Fade>
	);
};

export default ServiceUnavailable;
